import { connect, send } from "@/api/iori/socket";

const messageType = {
  //
    orientationMessage: "orientationMessage",
    alarmMessage: "alarmMessage",
    telecommandMessage: "telecommandMessage",
    telemeteringMessage: "telemeteringMessage"
};

const message = {
  state: {
    status: "", //连接状态
    subscribe: null, //订阅点
    wsMessage: {
      //不同的消息类型在此拓展
      orientationMessage: null, //定向消息
      alarmMessage: null, //告警消息
      telecommandMessage: null, //遥信消息
      telemeteringMessage: null, //遥测消息
    },
  },
  mutations: {
    SET_CONNECT: (state, status) => {
      state.status = status;
    },
    SET_SUBSCRIBE: (state, subscribe) => {
      state.subscribe = subscribe;
    },
    SET_WSMESSAGE: (state, message) => {
        let _jsonMsg = JSON.parse(message);
      if (_jsonMsg.type_ == messageType.orientationMessage) {
        state.wsMessage.orientationMessage = _jsonMsg.content_;
      } else if (_jsonMsg.type_ == messageType.alarmMessage) {
        state.wsMessage.alarmMessage = _jsonMsg.content_;
      } else if (_jsonMsg.type_ == messageType.telecommandMessage) {
        state.wsMessage.telecommandMessage = _jsonMsg.content_;
      } else if (_jsonMsg.type_ == messageType.telemeteringMessage) {
        state.wsMessage.telemeteringMessage = _jsonMsg.content_;
      }
    },
  },
  actions: {
    //设置消息连接状态
    SetSocketState({ commit }, status) {
      commit("SET_CONNECT", status);
    },
    //设置订阅值
    SetSubscribe({ commit }, subscribe) {
      send(subscribe);
      commit("SET_SUBSCRIBE", subscribe);
    },
    //设置消息
    SetMessage({ commit }, data) {
      commit("SET_WSMESSAGE", data);
    },
    //初始化连接
    InitConnect(store) {
      connect(store.getters.baseAuthToken);
    },
  },
};

export default message;
